<div class="flex flex-col h-full max-h-[calc(100vh-250px)] pt-4">

    @if (type === 'DYNAMIC') {
        @if (showFilters || hasRules) {
            <div class="grid grid-cols-2 gap-3 mb-6">
                <div class="bg-brand-50/50 dark:bg-brand-900/10 rounded-xl p-4 text-center border border-brand-100 dark:border-brand-800/50">
                    <h4 class="text-3xl font-black text-brand-600 dark:text-brand-400">{{ totalContactosPreview }}</h4>
                    <p class="text-[10px] font-bold text-brand-700/70 dark:text-brand-400/70 mt-1 uppercase tracking-wide">Cumplen</p>
                </div>
                <div class="bg-brand-50/50 dark:bg-brand-900/10 rounded-xl p-4 text-center border border-brand-100 dark:border-brand-800/50">
                    <h4 class="text-3xl font-black text-brand-600 dark:text-brand-400">{{ porcentajePreview }}%</h4>
                    <p class="text-[10px] font-bold text-brand-700/70 dark:text-brand-400/70 mt-1 uppercase tracking-wide">Del total</p>
                </div>
                <div class="col-span-2 bg-gray-50 dark:bg-gray-800/50 rounded-xl p-3 text-center border border-gray-100 dark:border-gray-700 flex items-center justify-center gap-2">
                    <span class="text-sm font-black text-gray-800 dark:text-gray-200">{{ totalContactosCrm }}</span>
                    <span class="text-xs font-medium text-gray-500 dark:text-gray-400">contactos totales en CRM</span>
                </div>
            </div>

            <div class="overflow-y-auto custom-scrollbar flex-1">
                @if (isLoadingPreview) {
                    <div class="flex flex-col justify-center items-center py-10">
                        <div class="animate-spin rounded-full h-8 w-8 border-b-2 border-brand-500 mb-2"></div>
                        <span class="text-xs text-gray-500 dark:text-gray-400">Calculando...</span>
                    </div>
                }

                @if (!isLoadingPreview && contactosPreview.length > 0) {
                    <div class="w-full">
                        <div class="flex items-center justify-between mb-3">
                            <h4 class="text-xs font-bold text-gray-500 dark:text-gray-400 uppercase tracking-wider">Afectados</h4>
                        </div>
                        <div class="border border-gray-200 dark:border-gray-700 rounded-xl divide-y divide-gray-100 dark:divide-gray-800 bg-white dark:bg-gray-900 shadow-sm overflow-hidden">
                            <table class="w-full text-left whitespace-nowrap">
                                <thead class="bg-gray-50 dark:bg-gray-800/50 border-b border-gray-200 dark:border-gray-700">
                                    <tr>
                                        <th class="px-4 py-3 text-[10px] font-bold text-gray-500 dark:text-gray-400 uppercase tracking-wider">Nombre</th>
                                        <th class="px-4 py-3 text-[10px] font-bold text-gray-500 dark:text-gray-400 uppercase tracking-wider">Contacto</th>
                                    </tr>
                                </thead>
                                <tbody class="divide-y divide-gray-100 dark:divide-gray-800">
                                    @for (contacto of contactosPreview; track contacto.id) {
                                    <tr class="hover:bg-gray-50 dark:hover:bg-gray-800/50 transition-colors">
                                        <td class="px-4 py-3"><span class="block text-xs font-bold text-gray-900 dark:text-white truncate max-w-[120px]">{{ contacto.fullname }} {{ contacto.lastname }}</span></td>
                                        <td class="px-4 py-3"><span class="block text-xs text-gray-600 dark:text-gray-400 truncate max-w-[120px]" [title]="contacto.mail">{{ contacto.mail || contacto.phone || 'Sin datos' }}</span></td>
                                    </tr>
                                    }
                                </tbody>
                            </table>
                        </div>
                        @if (previewTotalPages > 1) {
                        <div class="flex items-center justify-between mt-3 px-1">
                            <button (click)="previousPage()" [disabled]="previewPage === 0"
                                class="text-[11px] font-semibold px-3 py-1.5 rounded-lg border border-gray-200 dark:border-gray-700 text-gray-600 dark:text-gray-300 disabled:opacity-40 hover:bg-gray-50 dark:hover:bg-gray-800 transition-colors">
                                ← Anterior
                            </button>
                            <span class="text-[11px] text-gray-500 dark:text-gray-400 font-medium">{{ previewPage + 1 }} / {{ previewTotalPages }}</span>
                            <button (click)="nextPage()" [disabled]="previewPage >= previewTotalPages - 1"
                                class="text-[11px] font-semibold px-3 py-1.5 rounded-lg border border-gray-200 dark:border-gray-700 text-gray-600 dark:text-gray-300 disabled:opacity-40 hover:bg-gray-50 dark:hover:bg-gray-800 transition-colors">
                                Siguiente →
                            </button>
                        </div>
                        }
                    </div>
                }
                
                @if (!isLoadingPreview && contactosPreview.length === 0) {
                    <div class="text-center py-10 bg-gray-50 dark:bg-gray-800/30 rounded-xl border border-dashed border-gray-300 dark:border-gray-700">
                        <p class="text-sm font-medium text-gray-500 dark:text-gray-400 px-4">Ningún contacto cumple con los filtros actuales.</p>
                    </div>
                }
            </div>
        } @else {
            <div class="text-center py-16 flex-1">
                <div class="w-16 h-16 bg-gray-50 dark:bg-gray-800 rounded-full flex items-center justify-center mx-auto mb-4 border border-gray-100 dark:border-gray-700">
                    <svg class="w-8 h-8 text-gray-300 dark:text-gray-500" fill="none" stroke="currentColor" viewBox="0 0 24 24"><path stroke-linecap="round" stroke-linejoin="round" stroke-width="1.5" d="M15 12a3 3 0 11-6 0 3 3 0 016 0z"></path><path stroke-linecap="round" stroke-linejoin="round" stroke-width="1.5" d="M2.458 12C3.732 7.943 7.523 5 12 5c4.478 0 8.268 2.943 9.542 7-1.274 4.057-5.064 7-9.542 7-4.477 0-8.268-2.943-9.542-7z"></path></svg>
                </div>
                <p class="text-sm text-gray-500 dark:text-gray-400 mx-auto">Agrega reglas en el panel izquierdo para ver la simulación en vivo.</p>
            </div>
        }
    }

    @if (!type) {
        <div class="text-center py-16 flex-1">
            <p class="text-sm text-gray-400 dark:text-gray-500 mx-auto">Selecciona un tipo de segmento a la izquierda.</p>
        </div>
    }
</div>